import React from 'react';
import { Modal, SparkModalPortal, Text, sparkAssetUrl } from '@spark';
import '@/features/datasets/components/DataSelection/ImprovementMode.css';

/**
 * "Way to go!" celebration (Figma 5017:7404) — shown the moment every label
 * on the Data Editor meets its review goal, i.e. the Overall Progress card
 * reaches 100%. "Retrain Model" hands off to the task-page Retrain modal;
 * "Close" (and the header X / overlay) simply dismisses.
 */
const ReviewCompleteModal = ({ open, onClose, onRetrainClick }) => (
    <SparkModalPortal
        open={open}
        onClose={onClose}
        width={600}
        className="review-complete-modal-portal"
    >
        <Modal
            title=""
            showSubtitle={false}
            showScrollBar={false}
            showOverlay={false}
            fixedHeight={false}
            primaryLabel="Retrain Model"
            primaryDisableWhenReadOnly
            tertiaryLabel="Close"
            onPrimaryClick={onRetrainClick}
            onTertiaryClick={onClose}
            onCloseClick={onClose}
            className="review-complete-modal"
        >
            <div className="review-complete-modal__body">
                <img
                    className="review-complete-modal__illustration"
                    src={sparkAssetUrl('illustrations/illustration-party-popper.png')}
                    alt=""
                />
                <Text
                    variant="heading-5-semibold"
                    color="primary"
                    as="p"
                    className="review-complete-modal__title"
                >
                    Way to go!
                </Text>
                <Text
                    variant="base-regular"
                    color="secondary"
                    as="p"
                    className="review-complete-modal__copy"
                >
                    You have validated all labels, now you can retrain to improve model
                </Text>
            </div>
        </Modal>
    </SparkModalPortal>
);

export default ReviewCompleteModal;
